import React from 'react';
import './Loader.css';

interface LoaderProps {
    size?: number;  // Diameter in px
    color?: string; // Use CSS color value
}

const Loader: React.FC<LoaderProps> = ({
    size = 24,
    color = '#000',
}) => {
    return (
        <div
            className="loader"
            style={{
                transform: `scale(${size / 24})`,
                color,
            }}
            aria-label="Loading…"
            role="status"
        />
    );
};

export default Loader;
